/***
 *Â @FileName: input æ°å­è¾å¥æ¡çæ ¼å¼å
 *Â @Author: manyao.zhu
 *Â @Date: 2020-06-10 10:36:47
 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InputFormatterService {
  percentileReg = /(?!^)(\d{3})(?=(?:\d{3})*$)/g; // æ°å­ä¸ä½æ·»å éå·çæ­£å

  constructor() {}

  // åèäºå¥çæ¹æ³
  userToFixed(val: number | string, num: number) {
    val = Number(val);
    Number.prototype.toFixed = function(d) {
      let str = this + '';
      if (!d) {
        d = 0;
      }
      if (str.indexOf('.') === -1) {
        str += '.';
      }
      str += new Array(d + 1).join('0');
      if (new RegExp('^(-|\\+)?(\\d+(\\.\\d{0,' + (d + 1) + '})?)\\d*$').test(str)) {
        let s = '0' + RegExp.$2;
        const pm = RegExp.$1;
        const a = RegExp.$3.length;
        let b = true;
        let e: any;
        if (a === d + 2) {
          e = s.match(/\d/g);
          if (parseInt(e[e.length - 1], 10) > 4) {
            for (let i = e.length - 2; i >= 0; i--) {
              e[i] = parseInt(e[i], 10) + 1;
              if (e[i] === 10) {
                e[i] = 0;
                b = i !== 1;
              } else {
                break;
              }
            }
          }
          s = e.join('').replace(new RegExp('(\\d+)(\\d{' + d + '})\\d$'), '$1.$2');
        }
        if (b) {
          s = s.substr(1);
        }
        return (pm + s).replace(/\.$/, '');
      }
      return this + '';
    };

    return val.toFixed(num);
  }

  // æ°å­çç¾åä½å¤ç
  toPercentile(val: number | string) {
    val = val.toString();
    // æ²¡æå°æ°çæåµ
    if (val.indexOf('.') === -1) {
      return val.toString().replace(this.percentileReg, ',$1');
    }
    return this.percentileHandleDecimal(val);
  }

  // ç¾åä½å¤çå«æå°æ°çæåµ
  percentileHandleDecimal(str: string) {
    const arr = str.split('.');
    return `${arr[0].replace(this.percentileReg, ',$1')}.${arr[1]}`;
  }
}
